import http from '@/http';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getInstallation(context, params) {
      const response = await http.get(`installations/${params.ean}`,
        {
          params: {
            checkAgreementExistence: params.checkAgreementExistence,
          },
        });

      return response;
    },
    async getInstallationBookedCapacities(context, ean) {
      const response = await http.get(`installations/${ean}/booked-capacities`);

      return response;
    },
    async getPlannedOutageLinks() {
      const response = await http.get('installations/planned-outage/export/links');

      return response;
    },
  },
};
